import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ConfigService,
  launchConfigs,
  ltiParams,
  TranslationConfigService,
} from 'projects/up/src/public-api';
import { environment } from '../environments/environment';
import { SetLtiParams } from './shared/store/actions/ltiparams.action';

function initializeApp(): Promise<Record<string, string> | void> {
  const config = inject(ConfigService);
  const store = inject(Store);
  const translationConfigService = inject(TranslationConfigService);

  const cfg: launchConfigs = {
    createTokenApiUrl: `${environment.apiUrl}/up/jwt/token/create`,
    paramsApiUrl: `${environment.apiUrl}/vl/params`,
    redirectUrl: '',
    environmentName: environment.envName,
  };

  return config.processRequest(cfg).then(
    (ltiResponse: ltiParams) => {
      store.dispatch(new SetLtiParams({ ltiParams: ltiResponse }));
      return translationConfigService.setLocale(ltiResponse.lmsLocale);
    },
    () => {
      return translationConfigService.setLocale();
    },
  );
}

export { initializeApp };
